<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="colorDialogTitle" dark>{{ formTitle }}</v-toolbar>
      <v-container fluid>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <v-row justify="center" class="mt-4">
            <v-col cols="6" class="center">
              <v-card>
                <v-card-title class="justify-center"
                  ><h4>Datos para el ingreso al sistema</h4>
                </v-card-title>
                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="10">
                      <v-text-field
                        v-model="Usuario"
                        :append-icon="'mdi-account'"
                        :rules="[Validaciones.requerido]"
                        label="Usuario"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="10">
                      <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[Validaciones.requeridopassword]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        hint="Minimo 6 Caracteres"
                        label="Contraseña"
                        counter
                        dense
                        outlined
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <template v-if="this.colorDialogTitle == 'green'">
                    <v-row justify="center">
                      <span>{{ contraseñaPH }}</span>
                    </v-row>
                  </template>
                  <v-row justify="center">
                    <v-col cols="10">
                      <v-autocomplete
                        v-model="rolSeleccionado"
                        :items="listaRoles"
                        item-value="tipoUsuario"
                        item-text="tipoUsuarioDescripcion"
                        label="Rol"
                        filled
                        rounded
                        solo-inverted
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <template v-if="rolSeleccionado == 3">
                    <v-row justify="center">
                      <v-col cols="10">
                        <v-autocomplete
                          v-model="empresaSeleccionada"
                          :items="listaEmpresas"
                          item-value="idEmpresa"
                          item-text="descripcion"
                          label="Empresa"
                          filled
                          rounded
                          solo-inverted
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </template>
                  <v-row justify="center">
                    <v-col cols="5">
                      <!-- <v-text-field
                        :append-icon="'mdi-briefcase'"
                        :rules="[Validaciones.requerido]"
                        v-model="NroOT"
                        label="Nro. de OT Mantenimiento"
                        dense
                        outlined
                      ></v-text-field> -->
                      <!-- <v-select
                        v-model="otMantenimientoSeleccion"
                        :items="otMantenimiento"
                        item-value="ord_ot"
                        item-text="ord_ot"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[Validaciones.requerido]"
                        :readonly="readonlyContrator"
                        prepend-icon="mdi-badge-account-outline"
                        label="Nro de OT Mantenimiento"
                        no-data-text="No se encontraron contratistas"
                        hint="Seleccione la OT de Mantenimiento"
                        persistent-hint
                        :disabled="habilitarSelect"
                      ></v-select>
                    </v-col>
                    <v-col cols="5"> -->
                      <!-- <v-text-field
                        :append-icon="'mdi-briefcase'"
                        :rules="[Validaciones.requerido]"
                        v-model="NroOT"
                        label="Nro. de OT Comercial"
                        dense
                        outlined
                      ></v-text-field> -->
                      <!-- <v-select
                        v-model="otComercialSeleccion"
                        :items="otComercial"
                        item-value="ord_ot"
                        item-text="ord_ot"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[Validaciones.requerido]"
                        :readonly="readonlyContrator"
                        prepend-icon="mdi-badge-account-outline"
                        label="Nro de OT Comercial"
                        no-data-text="No se encontraron contratistas"
                        hint="Seleccione la OT Comercial"
                        persistent-hint
                        :disabled="habilitarSelect"
                      ></v-select> -->
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="mb-2">
                    <template v-if="colorDialogTitle == 'green'">
                      <v-btn
                        color="primary"
                        :loading="isSaving"
                        depressed
                        @click="editarUsuario()"
                      >
                        Guardar Edicion</v-btn
                      >
                    </template>

                    <template v-if="colorDialogTitle == 'indigo'">
                      <v-btn
                        color="primary"
                        :loading="isSaving"
                        depressed
                        @click="crearUsuario()"
                      >
                        Guardar</v-btn
                      >
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
        <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import sha512 from "js-sha512";
export default {
  data() {
    return {
      rolSeleccionado: "",
      empresaSeleccionada: "",
      listaEmpresas: [],
      listaRoles: [],
      empleadosUsuarioActual: [],
      habilitarSelect: false,
      otMantenimientoSeleccion: "",
      otComercialSeleccion: "",
      otMantenimiento: [],
      otComercial: [],
      colorDialogTitle: "",
      dialog: false,
      formValid: null,
      alertShow: false,
      isSaving: false,
      show1: false,
      hintContratista: "Seleccione el contratista",
      contraseñaPH: "Contraseña",
      readonlyContrator: false,
      SeleccionContratista: "Selección",
      empleados: [],
      empleadoSeleccionados: [],
      contratistas: [],
      contratistaSeleccion: null,
      tipoModal_IdUsuario: 0,
      Usuario: "",
      password: "",
      NroOT: "",
      Validaciones: {
        requeridoSelect: (v) =>
          v.length > 0 || "Debe seleccionar al menos un empleado",
        requerido: (v) => !!v || "Campo Requerido",
        requeridopassword: (v) => {
          if (v == null && this.tipoModal_IdUsuario === 0) {
            return "Mínimo 6 caracteres";
          }
          if (this.tipoModal_IdUsuario === 0) {
            !!v || "Campo Requerido";
          }
          if ((v == null || v === "") && this.tipoModal_IdUsuario > 0) {
            return true;
          } else if (v.length < 6) {
            return "Mínimo 6 caracteres";
          }

          return true;
        },
      },
    };
  },
  watch: {
    isSaving(val) {
      if (val) {
        setTimeout(() => (this.isSaving = false), 1500);
      } else {
        this.submitForm();
      }
    },
    async contratistaSeleccion() {
      if (this.tipoModal_IdUsuario == 0) {
        this.readonlyContrator = false;
        this.contraseñaPH = "Contraseña";
        this.hintContratista = "Seleccione el contratista";
        this.SeleccionContratista = "Selección";
        await this.getListarEmpleadosContratistasinUsuarioAsignada();
      } else {
        this.hintContratista = "";
        this.SeleccionContratista = "Contratista de la Usuario Armada";
        this.readonlyContrator = true;
        this.contraseñaPH = "Dejar en blanco si no cambia la Contraseña";
      }
    },
  },
  mounted() {
    this.getListarEmpresas();
    this.getListarRoles();

    // if (this.$store.getters.usuario.idRol === 3) {
    //   console.log("Ingreso con la cuenta de un contratista");
    //   this.contratistaSeleccion = this.$store.getters.usuario.idContratista;
    //   this.getListarEmpleadosContratistasinUsuarioAsignada();
    //   this.recuperarOTMantenimiento();
    //   this.recuperarOTComercial();
    //   // this.recuperarEmpleadoUsuario();
    // } else {
    //   this.getListarContratistas();
    // }
  },

  computed: {
    formTitle() {
      return this.tipoModal_IdUsuario === 0
        ? "Crear Usuario"
        : "Editar Usuario";
    },
    txtEmpleado() {
      return this.empleadoSeleccionados.length - 2 == 1
        ? "+1 empleado"
        : "+" +
            (this.empleadoSeleccionados.length - 2).toString() +
            " empleados";
    },
  },

  methods: {
    async getListarRoles() {
      console.log("Ingreso en listar roles");
      this.url =
        this.$store.getters.urlBase + "Usuarios/recuperarTiposUsuarios";

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Los tipos de usuarios son: ");
          console.log(response.data);
          this.listaRoles = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;

      this.dialog = false;
      this.$emit("recargarListado");
    },
    async getListarEmpresas() {
      console.log("Ingreso en listar empresas");
      this.url = this.$store.getters.urlBase + "Usuarios/recuperarEmpresas";

      await axios
        .get(this.url)
        .then((response) => {
          console.log("La lista de empresas: ");
          console.log(response.data);
          this.listaEmpresas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;

      this.dialog = false;
      this.$emit("recargarListado");
    },

    checkSelectionLimit() {
      if (this.empleadoSeleccionados.length > 3) {
        this.empleadoSeleccionados.pop();
      }
    },

    async crearUsuario() {
      this.url = this.$store.getters.urlBase + "Usuarios/ingresarUsuario";

      const params = {
        nombreUsuario: parseInt(this.Usuario),
        contraseña: sha512(this.password),
        idTipoUsuario: this.rolSeleccionado,
        idEmpresa: this.empresaSeleccionada,
        //ot: ots,
      };

      console.log("Los datos de las Usuarios para ingresar son");
      console.log(params);

      await axios
        .post(this.url, params)
        .then((response) => {
          console.log("Las ot mantenimiento son: ");
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;

      this.dialog = false;
      this.$emit("recargarListado");
    },

    async recuperarEmpleadoUsuario() {
      this.url =
        this.$store.getters.urlBase +
        "Usuario/recuperarPersonalUsuario?idUsuario=" +
        this.tipoModal_IdUsuario;

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          this.empleadosUsuarioActual = response.data;
          return response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.empleadosUsuarioActual = respuesta;
      console.log("Los empleados de la Usuario son: ");
      console.log(this.empleadosUsuarioActual);
    },

    async editarUsuario() {
      this.url = this.$store.getters.urlBase + "Usuarios/editarUsuario";

      var ots = [];
      var IdOT;
      var Tipo;

      if (this.otMantenimientoSeleccion != null) {
        IdOT = this.otMantenimientoSeleccion;
        Tipo = "M";
        ots.push({ IdOT: IdOT, Tipo: Tipo });
      }

      if (this.otComercialSeleccion != null) {
        IdOT = this.otComercialSeleccion;
        Tipo = "C";
        ots.push({ IdOT: IdOT, Tipo: Tipo });
      }

      //console.log("Las ot son");
      //console.log(ots);

      console.log("Los empleados seleccionados para la edicion son : ");
      console.log(this.empleadoSeleccionados);
      console.log(this.empleadosUsuarioActual);
      var empleadosEditados = this.empleadoSeleccionados
        .filter((empleado) => empleado !== null && empleado !== undefined)
        .map((empleado) => ({ ...empleado, estado: 1, dni: empleado }));

      console.log("Los empleados editados son: ");
      console.log(empleadosEditados);

      // Crear un conjunto de DNIs de empleados en empleadosEditados
      const dnisEmptySet = new Set(
        empleadosEditados.map((empleado) => empleado.dni)
      );

      // Filtrar empleados en empleadosUsuarioActual cuyos DNIs no están en empleadosEditados
      const empleadosFaltantes = this.empleadosUsuarioActual
        .filter((empleado) => !dnisEmptySet.has(empleado.dni))
        .map((empleado) => ({ estado: 0, dni: empleado.dni }));

      // Agregar los empleados faltantes a empleadosEditados
      const empleadosEditadosActualizados = [
        ...empleadosEditados,
        ...empleadosFaltantes,
      ];

      console.log("Los empleado editados son");
      console.log(empleadosEditadosActualizados);

      const params = {
        idUsuario: this.tipoModal_IdUsuario,
        PersonalUsuario: empleadosEditadosActualizados,
        cuenta: this.Usuario,
        contraseña:
          this.password == null || this.password == ""
            ? null
            : sha512(this.password),
      };

      await axios
        .post(this.url, params)
        .then((response) => {
          //console.log("Las ot mantenimiento son: ");
          console.log(response.data);
          this.otMantenimiento = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;

      this.dialog = false;

      this.$emit("recargarListado");
    },

    pruebaReset() {
      this.$refs.form.reset();
    },
    openModal(tipo) {
      this.habilitarSelect = false;
      this.colorDialogTitle = "indigo";
      this.tipoModal_IdUsuario = tipo;
      if (this.tipoModal_IdUsuario != 0) {
        this.getUsuariobyID(tipo);
      } else {
        this.empleados = [];
        this.contratistaSeleccion = [];
      }

      this.dialog = true;
    },

    AbrirModal() {
      this.colorDialogTitle = "indigo";
      this.dialog = true;
      //this.recuperarEmpleadoUsuario();
    },

    abrirModalModificarusuario(datos) {
      this.Usuario = datos.nombreUsuario;
      console.log("El nombre de usuario de la Usuario es ");
      console.log(this.Usuario);
      this.colorDialogTitle = "green";
      this.habilitarSelect = true;
      console.log("Los datos de la Usuario enviada son: " + datos);
      console.log(datos);
      this.tipoModal_IdUsuario = datos.idUsuario;
      if (this.tipoModal_IdUsuario != 0) {
        this.getUsuariobyID(datos.idUsuario);
        this.recuperarEmpleadoUsuario();
      } else {
        this.empleados = [];
        this.contratistaSeleccion = [];
      }
      this.dialog = true;

      console.log("El valor de habilitar");
      console.log(this.habilitarSelect);
      //this.recuperarEmpleadoUsuario();
    },
    close() {
      this.dialog = false;
      this.tipoModal_IdUsuario = 0;
      this.$refs.form.reset();
    },
    submitForm() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$emit("Recargar");
    },
    async getListarContratistas() {
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      var listacontratista = [];
      this.contratistas = listacontratista;

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.contratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },
    orderList() {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    async getListarEmpleadosContratistasinUsuarioAsignada() {
      console.log("El contratista seleccionado es");
      console.log(this.contratistaSeleccion);

      this.url = this.$store.getters.urlBase + "Employee/getlistByContrator";
      // this.$store.getters.urlBase + "Employee/getlistByContrator";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: {
          idcontratista:
            this.$store.getters.usuario.idRol != 3
              ? this.contratistaSeleccion
              : this.$store.getters.usuario.idContratista,
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      console.log("Los empleado del contratista son");
      console.log(respuesta.data);

      if (respuesta.status === 200) {
        this.empleados = respuesta.data;
      }
    },
    async getUsuariobyID(idUsuario) {
      this.url = this.$store.getters.urlBase + "Gang/GetActiveGangById";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: { idGang: idUsuario },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        this.contratistaSeleccion = respuesta.data.idEmpresa;
        //this.Usuario = respuesta.data.cuenta;
        this.NroOT = respuesta.data.idOT;
        console.log("los datos de getUsuariobyID");
        this.empleadosUsuarioActual = respuesta.data.empleados;
        console.log(this.empleadosUsuarioActual);
        await this.getListarEmpleadosContratistasinUsuarioAsignada();

        respuesta.data.empleados.forEach((element) => {
          this.empleados.push({
            idEmpleado: element.dni,
            nombreCompleto: element.apellido + " " + element.nombre,
          });
          this.empleadoSeleccionados.splice(1, 0, element.dni);
        });
      } else {
        this.colorSnack = "red";
        this.mensajeSnack = respuesta.data;
        this.Showsnackbar = true;
      }

      //Aqui recupero las ot

      this.url =
        this.$store.getters.urlBase +
        "OT/recuperarOTsXUsuario?idUsuario=" +
        this.tipoModal_IdUsuario;
      const options1 = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: { idGang: idUsuario },
        url: this.url,
      };
      respuesta = await axios(this.url, options1);
      if (respuesta.status === 200) {
        console.log("La respuesta de las ot son");
        console.log(respuesta.data);
        respuesta.data.forEach((item) => {
          const tipo = item.tipo;
          console.log("El codigo de orden es: ");
          console.log(item.ord_ot);
          console.log("El tipo de orden es: ");
          console.log(item.tipo);

          if (tipo == "M") {
            this.otMantenimientoSeleccion = item.ord_ot;
            console.log("La ot mantenimiento elejida es");
            console.log(this.otMantenimientoSeleccion);
          }
          if (tipo == "C") {
            this.otComercialSeleccion = item.ord_ot;
            console.log("La ot comercial elejida es");
            console.log(this.otComercialSeleccion);
          }
        });
      } else {
        this.colorSnack = "red";
        this.mensajeSnack = respuesta.data;
        this.Showsnackbar = true;
      }

      // console.log("La ot comercial elejida es");
      // console.log(this.otComercialSeleccion);

      // if (respuesta.data.tipo == "C") {
      //   this.otComercialSeleccion = respuesta.data.tipo;
      // }
      // if (respuesta.data.tipo == "M") {
      //   this.otMantenimientoSeleccion = respuesta.data.tipo;
      // }
    },
    OptionSave() {
      if (this.tipoModal_IdUsuario === 0) {
        console.log(this.empleadoSeleccionados);
        this.InsertarUsuario();
      } else {
        console.log(this.empleadoSeleccionados);
        this.UpdateUsuario();
      }
    },
    async UpdateUsuario() {
      if (this.$refs.form.validate()) {
        this.url = this.$store.getters.urlBase + "Gang/updategang";

        console.log("Los empleados seleccionados son: ");
        console.log("");

        var gangModel = {
          GangID: this.tipoModal_IdUsuario,
          EmployeesId: this.empleadoSeleccionados,
          Password: this.password,
          Account: this.Usuario,
          OTId: this.NroOT,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.usuario.token}`,
          },
        };
        await axios
          .post(this.url, gangModel, config)
          .then(
            (response) => (this.respuesta = response),
            (this.isSaving = true)
          )
          .catch((e) => {
            this.colorSnack = "red";
            this.mensajeSnack = e.data;
            this.Showsnackbar = true;
          });
      }
    },
    async InsertarUsuario() {
      if (this.$refs.form.validate()) {
        this.url = this.$store.getters.urlBase + "Gang/insertgang";

        this.ots = [this.otMantenimientoSeleccion, this.otComercialSeleccion];

        console.log("los empleados son: ");
        console.log(this.empleadoSeleccionados);

        console.log("La contraseña es: ");
        console.log(this.password);

        console.log("la cuenta es: ");
        console.log(this.Usuario);

        console.log("la ot es: ");
        console.log(this.ots);

        var gangModel = {
          EmployeesId: this.empleadoSeleccionados,
          Password: this.password,
          Account: this.Usuario,
          OTId: this.otMantenimientoSeleccion,
        };
        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
        //   },
        // };
        await axios
          .post(this.url, gangModel)
          //.post(this.url, gangModel, config)
          .then(
            (response) => (this.respuesta = response),
            (this.isSaving = true)
          )
          .catch((e) => {
            this.colorSnack = "red";
            this.mensajeSnack = e.data;
            this.Showsnackbar = true;
          });
      }
    },
  },
};
</script>
